const isItEstimateOrService = (chosenRequestType: string, userType: string): string => {
  if (userType === 'COOPERCITRUS') {
    return 'SERVICO';
  }

  return chosenRequestType;
};

export {
  isItEstimateOrService,
};
